import * as types from "../../actions/ActionTypes";

const initialState = { loading: false, data: [], error: null };

const getRelatedBusinessesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_RELATED_BUSINESSES_START:
            return { ...state, loading: true, error: null };
        case types.GET_RELATED_BUSINESSES_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case types.GET_RELATED_BUSINESSES_ERROR:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default getRelatedBusinessesReducer;
